import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { DiscussionService } from 'src/app/shared-service/services/discussion.service';
import { PreviewPostImageComponent } from '../preview-post-image/preview-post-image.component';
import { SocialShareComponent } from '../social-share/social-share.component';
import { take } from 'rxjs/operators'
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { AppConfig } from 'src/app/app.config';
@Component({
  selector: 'post-card',
  templateUrl: './post-card.component.html',
  styleUrls: ['./post-card.component.css']
})
export class PostCardComponent implements OnInit {

  @Input()
  postData:any;
  @Input()
  isCustomHeight=false;
  @Input()
  baseUrl:any;
  @Input()
  indexEle:any;
  @Output()
  reportPostIndex = new EventEmitter();

  isLoggedin=false;
  userId='';
  userData:any;

  baseUrlPage = '';
  rootUrl = '';
  playstoreLink =  '';
  phoneNo =  '';
  address =  '';
  emailId =  '';
  isdCode = '';
  domain = '';
  titleName ='';
  imageUrl='';

  slideConfig = {
    // "slidesToShow": 1,
     "slidesToScroll": 1,
     "infinite": false,
     "autoplay": false,
     "autoplaySpeed": 2000,
    "speed":10,
     "responsive": [
       {
         "breakpoint": 2000,
         "settings": {"slidesToShow": 3 }
       },
         {
           "breakpoint": 1200,
           "settings": {"slidesToShow": 2 }
         },
         {
           "breakpoint": 800,
           "settings": {"slidesToShow": 1 }
         },
       ]
   };
   profileUrl ='';
    customProfileName='';
    colorPallete = ['green','pink','orange','red','blue', 'gold', 'yelow','violet','silver'];
    colorPick = '';
   public perfectconfig: PerfectScrollbarConfigInterface = {
     suppressScrollY: true,
     suppressScrollX: false
   };

  constructor( private discussionService: DiscussionService,
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,private config: AppConfig) {
      this.baseUrlPage = this.config.getConfig('DISCUSS_BASE_URL');
      this.rootUrl = this.config.getConfig('DISCUSS_API_URL');
      this.playstoreLink =  this.config.getConfig('MOBILE_PLAYSTORE_URL');
      this.phoneNo =  this.config.getConfig('PHONE_NO');
      this.address =  this.config.getConfig('ADDRESS');
      this.emailId =  this.config.getConfig('EMAIL_ID');
      this.isdCode = this.config.getConfig('PHONE_ISD_CODE');
      this.domain = this.config.getConfig('DOMAIN');
      this.titleName =this.config.getConfig('TITLE');
      this.imageUrl =this.config.getConfig('DISCUSS_IMAGE_URL');
     }

  ngOnInit(): void {
    console.log('rendering....')
    if (localStorage.getItem('userData')){
      this.userData = JSON.parse(localStorage.getItem('userData'));
      this.userId = this.userData.user_id;
    }
    if(this.postData.user_image && this.postData.user_image.indexOf('dummy-profile') == -1) {
      this.profileUrl = this.postData.user_image;
    } else {
      this.customProfileName = this.postData.userName.charAt(0).toUpperCase()
    //  this.customProfileName = 'UK';
      this.colorPick = this.colorPallete[Math.floor(Math.random() * 9)]
    }
  }


  addRemoveUpvote(forum_id, post_type){
    var formData:any = new FormData();
    formData.append('discussion_type', post_type);
    formData.append('discussion_id', forum_id);
    formData.append('user_id', this.userId);
    this.discussionService.addRemoveUpvote(formData).subscribe((result:any) => {
      if(result && result.data && result.data.totlikeData != false) {
        this.postData.totLikes=result.data.totlikeData;
      } else if(this.postData.totLikes != 0) {
        this.postData.totLikes = this.postData.totLikes-1;
      }
    })
  }

  public onScrollEvent(event: any): void {
  }

  openShare(url) {
    var loginRoute = '0';
    if(this.userId) {
      loginRoute = '1';
      url = '/user'+url;
    }
    var urlToShare = this.discussionService.redirectBaseUrl + 'redirect?url=' + url+'&login='+loginRoute;
    const initialState = { urlToShare};
    this.modalService.show(SocialShareComponent, {initialState}).content.onHide
    .pipe(take(1))
    .subscribe((result: boolean) => {
        this.addShare();
    });
  }

  addShare() {
    var formData:any = new FormData();
    formData.append('discussion_type', this.postData.forum_type);
    formData.append('discussion_id',  this.postData.forum_id);
    formData.append('user_id', this.userId);
    this.discussionService.addShare(formData).subscribe((result:any) => {
      if(result && result.data) {
        this.postData.totShare = this.postData.totShare +1;
    }
    })
  }

  showPreviewImage(image) {
    const initialState = {image:image};
    this.bsModalRef = this.modalService.show(PreviewPostImageComponent, {initialState});
  }

  reportPost() {
    var formData:any = new FormData();
   // formData.append('discussion_type', this.postData.forum_type);
    formData.append('discussion_id',  this.postData.forum_id);
    formData.append('user_id', this.userId);
    this.discussionService.reportPost(formData).subscribe((result:any) => {
      if(result && result.data) {
        this.reportPostIndex.emit(this.indexEle);
        const initialState = {title:'Post Reported', description: 'Your report has been submitted successfully. This post will no longer be visible to you'};
        this.modalService.show(BasePopupComponent, {initialState})
      }
    })
  }


}
